/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { format, parseISO } from 'date-fns';
import { SecurityHelper } from 'sarsaparilla';
import * as types from '../constants';

const propTypes = {
    userTrips: PropTypes.array,
    tripIdeas: PropTypes.array,
    onTripIdeaSelected: PropTypes.func,
};

const defaultProps = {};

export default class TripPlannerSidemenu extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            viewAll: false,
        };
    }

    onTripIdeaSelected(trip) {
        if (this.props.onTripIdeaSelected) {
            this.props.onTripIdeaSelected(trip);
        }
    }

    render() {
        let trips = null;
        if (SecurityHelper.isLoggedIn() && this.props.userTrips) {
            trips = [];
            trips.push(<h3 key={'title'}>Your Saved Trips</h3>);
            trips.push(
                <ul key={'list'}>
                    {this.props.userTrips.slice(0, 5).map((trip, index) => {
                        const dt = format(
                            parseISO(trip.updated_date),
                            types.FNS_LL_DATE_FORMAT
                        );
                        return (
                            <li key={index}>
                                <Link to={`/trips/${trip.trip_id}`}>{trip.name}</Link>
                                <p>Last edited on {dt}</p>
                            </li>
                        );
                    })}
                </ul>
            );
        }
        let tripIdeas = null;
        if (this.props.tripIdeas) {
            tripIdeas = [];
            tripIdeas.push(<h3 key={'title'}>Trip Ideas</h3>);
            tripIdeas.push(
                <ul key={'list'}>
                    {this.props.tripIdeas.slice(0, 5).map((trip, index) => {
                        return (
                            <li key={index}>
                                <button
                                    type="button"
                                    className={'rec-button-link'}
                                    onClick={this.onTripIdeaSelected.bind(this, trip)}
                                >
                                    {trip.name}
                                </button>
                            </li>
                        );
                    })}
                </ul>
            );
        }
        return (
            <div className="trip-planner-left-rail-wrap">
                {tripIdeas}
                {trips}
            </div>
        );
    }
}

TripPlannerSidemenu.propTypes = propTypes;
TripPlannerSidemenu.defaultProps = defaultProps;
